import {materials} from "./materials";
import {link} from "./links";
import {video} from "./video";
import {over} from "./over";

export const chemistryMaterials = [
    {
        id: 1,
        materials: materials,
        links: link,
        video: video,
        tests: over,
        menuItemId: 4
    },
]
